import React, { useMemo, useState, useEffect } from 'react';
import Vendorproductt from './Vendorproduct';
import { Card, Modal, Form, Button, Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { FiPlusCircle } from 'react-icons/fi';
import { HiOutlineMinusCircle } from 'react-icons/hi';
import { FaEye } from "react-icons/fa";
import { FaSearch, FaPlus, FaEdit } from "react-icons/fa";
// import { MdDelete } from "react-icons/md";

import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';



import axios from 'axios';
import OrderProductRawMaterialView from '../Venderrecive/OrderProductRawMaterialView';
import CustumerProductview from '../Venderrecive/CustumerProductview';
import VendorReceiveView from '../Venderrecive/VendorReceiveView';
import AddReceive from '../Venderrecive/AddReceive';

const VendorProductdetails = () => {
    const token = localStorage.getItem('token');
    const [orderlist, setOrderList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [rowMatrialslist, setRowMatrialslist] = useState([]);
    const [Rows, setRows] = useState([]);
    const [counters, setCounters] = useState([]);
    const [VendorTrading, setVendorTrading] = useState([]);
    const [VendorId, setVendorID] = useState([]);
    const [manufacturee, setManufacture] = useState([]);
    const [VendorManufactureID, setVendorManufactureID] = useState("");
    const [fields, setFields] = useState({
        date: '',
        vender_id: '',
        product_id: '',
        qty: '',
    });
    const [modalData, setModalData] = useState({
        order_id: '',
        vender_id: '',
        item_id: '',
        product_id: '',
        qty: 1,
        unit_price: '',
    });
    const [modalState, setModalState] = useState({
        addVendor: false,
        addReceive: false,
        orderProductView: false,
        orderVendorView: false,
    });

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // console.warn(initialProductDetails);
    const [productDetails, setProductDetails] = useState({});
    const handleInputChange = (order_id, product_order_id, vendor_id, product_id, qty, key, value, vdr_id) => {
        // Update product details state with new value
        fetchProducts(order_id);
        if (!vdr_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please add the price first!',
            });
            return;
        }
        // alert(order_id)
        // setProductDetails(prevDetails => {
        //     const updatedDetails = {
        //         ...prevDetails,

        //         [vendor_id]: {
        //             ...prevDetails[vendor_id],
        //             [product_id]: {
        //                 ...prevDetails[vendor_id]?.[product_id],
        //                 [qty]: {
        //                     ...prevDetails[vendor_id]?.[product_id]?.[qty],
        //                     [key]: value,
        //                 }
        //             }
        //         }
        //     };

        //     // Return the updated state
        //     return updatedDetails;
        // });

        const payload = {
            order_id: order_id,
            vender_id: VendorId,
            item_id: vdr_id,
            product_id: product_order_id,
            qty: qty || 1,
            date: key == 'date' ? value : '',
            // unit_price: key == 'unit_price' ? value : '',
        };

        // if(VendorId && !vdr_id){

        //     handleSubmit(payload);

        // }
        console.warn("dfgdf", VendorId)
        if (VendorId && vdr_id) {
            // setTimeout(() => {

            handleUpdateDate(payload);
            // },2000)
        }

    }

    const handleInputChange1 = (order_id, product_order_id, vender_id, product_id, qty, key, value, category_id, vdr_id, unit_price) => {
        handleShow();
        const payload = {
            order_id: order_id,
            vender_id: vender_id,
            product_order_id: product_order_id,
            item_id: vdr_id,
            product_id: product_id,
            qty: qty,  // Default to 1 if qty is falsy
            unit_price: unit_price,
            category_id: category_id,

        };
        setVendorManufactureID(vdr_id);


        // handleSubmit1(payload);
        fetchProducts(order_id);
        setProductDetails(prevDetails => {
            const updatedDetails = {
                ...prevDetails,
                [vender_id]: {
                    ...prevDetails[vender_id],
                    [product_id]: {
                        ...prevDetails[vender_id]?.[product_id],
                        [key]: value,
                    },
                },
            };
            return updatedDetails;
        });
        console.log("ppppppppp,", payload)
        // Set modal data state with the payload
        setModalData({
            order_id: payload.order_id,
            vender_id: payload.vender_id,
            item_id: payload.item_id,
            product_id: payload.product_id,
            product_order_id: payload.product_order_id,
            qty: payload.qty,
            unit_price: payload.unit_price,
            area_description_id: payload.area_description_id,
            category_id: payload.category_id,
        });

    };


    const handleSubmit = async (payload) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-Row-Matrials-store`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1) {
                // toast.success(response.data.message);
                fetchOrderlist();
            } else {
                // toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred');
        }
    };
    const handleUpdateDate = async (payload) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-update-date-Row-Matrials-store-price/${payload.item_id}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (response.data.status === 1) {
                // toast.success(response.data.message);
                fetchOrderlist();
            } else {
                // toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred');
        }
    };


    const handleSubmit1 = async () => {


        const newpayload = {
            order_id: modalData.order_id,
            vender_id: VendorId,
            category_id: modalData.category_id,
            item_id: modalData.product_order_id,
            product_id: modalData.product_id,
            product_order_id: modalData.product_order_id,
            qty: Number(modalData.qty),
            unit_price: Number(modalData.unit_price),
            manufacture: "Trading"
        };
        console.warn("newpayload", newpayload)
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-Trading-Row-Matrials-store-price`, newpayload, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token, // Ensure token is defined
                },
            });

            if (response.data.status === 1) {
                // Toast success or any action after success
                fetchOrderlist(); // Refresh the order 

            } else {
                // Handle error from backend response
                console.error(response.data.message);
                // toast.error(response.data.message);
            }
            handleClose();
            setModalData('')
        } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred');
        }
    };
    const handleUpdate = async () => {


        const newPayload = {
            order_id: modalData.order_id,
            vender_id: VendorId,
            category_id: modalData.category_id,
            item_id: modalData.item_id,
            id: modalData.item_id,
            product_id: modalData.product_id,
            component_id: modalData.component_id,
            product_order_id: modalData.product_order_id,
            qty: Number(modalData.qty),
            unit_price: Number(modalData.unit_price),
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}Receive-Product-update-Trading-Row-Matrials-store-price/${modalData.item_id}`,
                newPayload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token, // Ensure `token` is defined and valid
                    },
                }
            );

            if (response.data.status === 200) {
                fetchOrderlist(); // Refresh the order list
                handleClose(); // Close modal
            } else {
                console.error(response.data.message);
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error(error.response?.data?.message || 'An unexpected error occurred');
        }
    };

    // const handleSubmit1 = async () => {

    //     if (manufacturee === 'Manufacture') {
    //         if (!modalData.vender_id) {
    //             alert('Vendor Name is required');
    //             return;
    //         }
    //         if (!modalData.component_id) {
    //             alert('Component Name is required');
    //             return;
    //         }
    //     }
    //     const newpayload = {
    //         order_id: modalData.order_id,
    //         vender_id: modalData.vender_id,
    //         item_id: modalData.item_id,
    //         product_id: modalData.product_id,
    //         product_order_id: modalData.product_id, // Assuming product_order_id and product_id are the same
    //         qty: Number(modalData.qty),
    //         unit_price: Number(modalData.unit_price),
    //     };
    //     console.warn("newpayload", newpayload)
    //     try {
    //         const response = await axios.post(`${process.env.REACT_APP_API_URL}Add-Receive-Product-Row-Matrials-store-price`, newpayload, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'x-access-token': token, // Ensure token is defined
    //             },
    //         });

    //         if (response.data.status === 1) {
    //             // Toast success or any action after success
    //             fetchOrderlist(); // Refresh the order 

    //         } else {
    //             // Handle error from backend response
    //             console.error(response.data.message);
    //             // toast.error(response.data.message);
    //         }
    //         handleClose();
    //     } catch (error) {
    //         console.error('Error:', error);
    //         toast.error('An error occurred');
    //     }
    // };

    const navigate = useNavigate();

    useEffect(() => {
        if (!modalState.addReceive) {
            fetchOrderlist();


        }
    }, [modalState.addReceive, token]);

    const fetchOrderlist = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Crete-custumer-product-name-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const orders = response.data.data || [];
            console.warn("dfgdf", orders);


            const filteredOrders = orders
                .filter(order => order.manufacture === 'Trading')
                .sort((a, b) => b.id - a.id);

            setOrderList(filteredOrders);

            const initialDetails = {};
            filteredOrders.forEach(order => {
                const customerName = order.customer_name;
                const manufacture = order.manufacture;

                setProductDetails(prevFields => ({
                    ...prevFields,
                    CustumerName: customerName,
                    manufacture: manufacture,
                }));

                order.product_data.forEach(product => {
                    initialDetails[product.vdr_id] = {
                        product_id: product.product_id,
                        order_id: product.order_id,
                        vdr_id: product.vdr_id,
                        vender_id: product.vender_id,
                        qty: product.qty,
                        unit_price: product.unit_price,
                        date: product.date,
                        manufacture: product.manufacture,
                        customerName,
                    };
                });
                console.warn(initialDetails);
            });
            setProductDetails(initialDetails);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };


    const fetchProducts = async (order_id) => {
        try {
            const url = `${process.env.REACT_APP_API_URL}Order-view-product-list/${order_id}`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            const { createOrder, product, component_order, sub_component_order, extra_charges_store, product_other_data } = response.data.rows;
            const orderDetails = createOrder[0];
            // setViewData({
            //     ...orderDetails,
            //     products: product,
            //     componentOrder: component_order,
            //     subcomponentOrder: sub_component_order,
            //     extra_products: extra_charges_store,
            //     otherData: product_other_data || []
            // });
            const customerData = orderDetails;
            // console.warn(customerData)
            // setFormData({
            //     customer_id: customerData.id,
            //     account_id: customerData.account_id,
            //     due_amt: customerData.due_amt,
            //     order_date: customerData.order_date,
            //     customer_name: customerData.customer_name,
            //     customer_type: customerData.customer_type,
            //     invoice_number_manual: customerData.invoice_number_manual,
            //     description: customerData.description,
            //     mobile_number: customerData.mobile_number,
            //     site_name: customerData.site_name,
            //     pincode: customerData.pincode,
            //     email: customerData.email,
            //     city: customerData.city,
            //     state: customerData.state,
            //     address1: customerData.address1,
            //     address2: customerData.address2,
            //     account_name: customerData.account_id,
            //     account_mode: customerData.account_mode,
            //     payer_name: customerData.payer_name,
            //     receiver_name: customerData.receiver_name,
            //     amount: customerData.amount,
            //     total_price: customerData.total_price,
            //     delivery_date: customerData.delivery_date,
            //     manufacture: orderDetails.manufacture,
            //     c_gst: orderDetails.c_gst,
            //     s_gst: orderDetails.s_gst,
            //     total_amount: orderDetails.total_amount,
            //     gst_in_no: orderDetails.gst_in_no,
            //     vehicle_number: orderDetails.vehicle_number,

            // });


            if (product.length > 0) {

                const uniqueProductIds = new Set();
                let updatedRows = product
                    .filter(item => {
                        // Check if product_id is already in the Set
                        if (uniqueProductIds.has(item.product_id)) {
                            return false; // Skip duplicates
                        }
                        uniqueProductIds.add(item.product_id);
                        return true; // Include unique items
                    })
                    .map(item => ({
                        id: item.product_order_id,
                        order_id: item.order_id,
                        vendor_id: item.vender_id,
                        category_id: item.category_id,
                        product_id: { id: item.product_id, name: item.name },
                        qty: item.qty,
                        qty_old: item.qty,
                        pro_qty: item.pro_qty,
                        price: item.price,
                        gst: item.gst,
                        manufacture: item.manufacture,
                        pro_unit: item.pro_unit,
                        hsn_no: item.hsn_no,
                        total_amount: item.total_amount,
                        sale_price: item.sale_price,
                        area_id: Number(item.area_id),
                        component_order: []
                    }));

                console.warn("areacheckkkk", updatedRows)


                if (component_order.length > 0) {
                    updatedRows = updatedRows.map(row => ({
                        ...row,
                        component_order: component_order
                            .filter(component => component.product_id === row.product_id.id) // Match category_id
                            .map(component => ({
                                id: component.id,
                                area_description: component.area_description,
                                area_id: Number(component.area_id),
                                cost_price: component.cost_price,
                                sale_price: component.sale_price,
                                category_id: component.category_id,
                                product_id: component.product_id,
                                area_description_id: component.area_description_id,
                                sub_component_order: [] // Placeholder for nested sub_component_order
                            }))
                    }));
                }


                if (sub_component_order && sub_component_order.length > 0) {

                    updatedRows = updatedRows.map(row => ({
                        ...row,
                        component_order: row.component_order.map(component => ({
                            ...component,
                            sub_component_order: sub_component_order.filter(subComponent =>
                                component.area_description_id == subComponent.area_description_id
                            ).map(subComponent => ({
                                id: subComponent.id,
                                area_des_id: component.id,
                                component_id: subComponent.component_id,
                                area_description_id: subComponent.area_description_id,
                                vender_id: subComponent.vender_id,
                                category_id: subComponent.category_id,
                                area_id: Number(subComponent.area_id),
                                component_name: subComponent.component_name,
                                vendor_name: subComponent.vendor_name
                            }))
                        }))
                    }));

                }


                setRows(response.data.rows.sub_component_order);

                // Map product data
                let updatedRowsss = product.map(item => ({
                    id: item.product_order_id,
                    order_id: item.order_id,
                    vendor_id: item.vender_id,
                    vendor_name: item.vendor_name,
                    category_id: item.category_id,
                    product_id: { id: item.product_id, name: item.name },
                    qty: item.qty,
                    qty_old: item.qty,
                    pro_qty: item.pro_qty,
                    price: item.price,
                    product_order_id: item.product_order_id,
                    gst: item.gst,
                    manufacture: item.manufacture,
                    pro_unit: item.pro_unit,
                    hsn_no: item.hsn_no,
                    total_amount: item.total_amount,
                    sale_price: item.sale_price,
                    area_id: Number(item.area_id),
                    component_order: []
                }));

                if (updatedRowsss.length > 0) {
                    const { vendor_name, vendor_id, manufacture } = updatedRowsss[0];
                    setVendorTrading(vendor_name);
                    setVendorID(vendor_id);
                    setManufacture(manufacture);
                    console.log("MMMMMMMMMM:", manufacture);
                    console.log("Vendor ID:", vendor_id);
                } else {
                    console.log("No data found in the updatedRowsss array.");
                }
            }

            if (extra_charges_store.length > 0) {
                const updatedRows = extra_charges_store.map(item => ({
                    id: item.id,
                    order_id: item.order_id,
                    customer_id: item.customer_id,
                    category_id: item.category_id,
                    name: item.name,
                    pro_qty: item.pro_qty,
                    price: item.price,
                    total_amount: item.total_amount,
                    vendor_id: item.vendor_id,

                }));
                // setRows1(updatedRows);
            }
            if (product_other_data.length > 0) {
                const updatedRowsother = product_other_data && product_other_data.map(item => ({
                    tr_charge: item.tr_charge,
                    lable_charge: item.lable_charge,
                    id: item.id,
                    // name: item.name || '',
                }));
                // setRowother(updatedRowsother);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };



    // setRows();        


    const ProductView = async (order) => {
        localStorage.setItem('Vendor_view_id', order);
        setModalState({ ...modalState, orderVendorView: true });
    };
    const VendorRecriveStatusChange = async (vendorId, newStatus) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Status it!",
            });

            if (result.isConfirmed) {
                const token = localStorage.getItem('token');
                const url = `${process.env.REACT_APP_API_URL}Vendor-receive-status/${vendorId}`;

                const config = {
                    method: 'post',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                    data: {
                        status: newStatus,
                    },
                };

                const response = await axios(config);

                if (response.data.status === 1) {
                    toast.success(response.data.message);
                    fetchOrderlist();
                } else {
                    toast.error(response.data.message);
                }
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Error updating status. Please try again later.");
        }
    };

    const VendorDelete = async (order) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                let url = `${process.env.REACT_APP_API_URL}Vendor-receive-delete/${order}`;
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                };
                const response = await axios(config);
                if (response.data.status === 1) {
                    toast.success(response.data.message);
                    fetchOrderlist();
                } else {
                    toast.error(response.data.message);
                }
            }
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            // setLoadinglist(false);
        }
    };

    const handleView = (order) => {
        localStorage.setItem('orderRawproduct_id', order);
        setModalState({ ...modalState, orderProductView: true });
    };
    const handleViewProduct = (id) => {
        localStorage.setItem('product_view_id', id);
        setModalState({ ...modalState, orderProductView: true });
    };

    const vendorProductColumns = useMemo(
        () => [
            {
                Header: 'Sr No',
                accessor: (row, i) => i + 1,
            },
            {
                Header: 'Or. Id',
                accessor: 'order_id',
            },
            {
                Header: 'Cu. Name',
                accessor: 'customer_name',
            },
            {
                Header: 'Cu. Type',
                accessor: 'customer_type',
            },
            // {
            //     Header: 'Type',
            //     accessor: 'product_data',
            //     id: 'manufacture',
            //     Cell: ({ cell: { value } }) => (
            //         <tbody className='table_child'>
            //             {value.map((product, index) => (
            //                 <tr key={index}>
            //                     <td>{product.manufacture}</td>
            //                 </tr>
            //             ))}
            //         </tbody>
            //     ),
            // },
            {
                Header: 'Order',
                accessor: 'product_data',
                id: 'product_name',
                Cell: ({ cell: { value } }) => (
                    <tbody className='table_child'>
                        {value.map((product, index) => (
                            <tr key={index}>
                                <td className='mb-0'>{product.name}</td>
                            </tr>
                        ))}
                    </tbody>
                ),
            },
            // {
            //     Header: 'Vendor',
            //     accessor: 'product_data',
            //     id: 'veder_name',
            //     Cell: ({ cell: { value } }) => (
            //         // <table>
            //         <tbody className='table_child'>
            //             {value && value.map((product, index) => (
            //                 <tr key={index}>
            //                     <td>{product.veder_name}</td>
            //                 </tr>
            //             ))}
            //         </tbody>
            //         // </table>
            //     ),
            // },
            {
                Header: 'Ve. Date',
                accessor: 'product_data',
                id: 'date',
                Cell: ({ cell: { value }, row }) => (
                    <tbody>
                        {value && value.map((product, index) => (
                            <tr key={index}>
                                <td>
                                    <Col md={12} sm={12}>
                                        <Form.Group>
                                            <Form.Control
                                                type="date"
                                                placeholder="Enter Date"
                                                className='w-auto-design'
                                                name="date"
                                                value={
                                                    productDetails[product.order_id]?.[product.vender_id]?.[product.product_id]?.[product.qty]?.date ||
                                                    product.date
                                                    // new Date().toISOString().split("T")[0] // Default to today's date
                                                }
                                                onChange={(e) => handleInputChange(
                                                    product.order_id,
                                                    product.product_order_id,
                                                    product.vendor_id,
                                                    product.product_id,
                                                    product.qty,
                                                    'date',
                                                    e.target.value,
                                                    product.vdr_id,
                                                )}
                                                onFocus={(e) => e.target.showPicker()} // Open date picker on focus
                                            />
                                        </Form.Group>
                                    </Col>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ),
            },


            {
                Header: 'Price',
                accessor: 'product_data',
                id: 'unit_price',

                Cell: ({ cell: { value }, row }) => {
                    // const formatPrice = (price) => {
                    //     if (price === undefined || price === null) return '';
                    //     return new Intl.NumberFormat().format(price);
                    // };
                    const formatPrice = (price) => {
                        if (price === undefined || price === null) return '';
                        return price.toString(); // Converts the price to a string without adding commas
                    };

                    return (
                        <tbody>
                            {value && value.map((product, index) => (
                                <tr key={index}>
                                    <td>
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                placeholder="Price"
                                                name="unit_price"
                                                className='w-auto-design'
                                                value={formatPrice(
                                                    productDetails[row.order_id]?.[product.vender_id]?.[product.product_id]?.[product.qty]?.unit_price
                                                    ?? product.unit_price
                                                )}
                                                disabled

                                            />

                                        </Form.Group>
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-primary"
                                            // onClick={() => handleButtonClick(product)}
                                            onClick={(e) => handleInputChange1(
                                                product.order_id,
                                                product.product_order_id,
                                                product.vender_id,
                                                product.product_id,
                                                product.qty,
                                                'unit_price',
                                                e.target.value,
                                                product.category_id,
                                                product.vdr_id,
                                                product.unit_price,
                                            )}
                                        >
                                            <FaEdit />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    );
                },
            },

            {
                Header: 'S Price',
                accessor: 'product_data',
                id: 'price',
                Cell: ({ cell: { value }, row }) => {
                    const formatPrice = (price) => {
                        if (price === undefined || price === null) return '';
                        return new Intl.NumberFormat().format(price);
                    };

                    return (
                        <>
                            {value && value.map((product, index) => (
                                <tr key={index}>
                                    <td>
                                        <Form.Group>
                                            <Form.Control
                                                type="text"
                                                placeholder="Price"
                                                name="unit_price1"
                                                className='w-auto-design'
                                                value={formatPrice(product.price)}
                                                disabled
                                            />
                                        </Form.Group>
                                    </td>
                                </tr>
                            ))}
                        </>
                    );
                },
            },



            {
                Header: 'Receive',
                accessor: 'product_data',
                id: 'status',
                Cell: ({ cell: { value } }) => (
                    <tbody>
                        {value && value.map((product, index) => (
                            <tr key={index}>
                                {/* {product.date !== null && ( */}
                                <td style={{ color: product.status === 1 ? 'green' : 'red' }}>
                                    <select
                                        className='form-select w-auto noborder'
                                        style={{ color: product.status === 1 ? 'green' : 'red' }}
                                        defaultValue={product.status === 1 ? 'Yes' : 'No'}
                                        onChange={(e) => {
                                            const newStatus = e.target.value === 'Yes' ? 1 : 0;
                                            VendorRecriveStatusChange(product.vdr_id, newStatus);
                                        }}
                                    >
                                        <option value="Yes" className='text-success' selected={product.status === 1}>Yes</option>
                                        <option value="No" className='text-danger' selected={product.status === 0}>No</option>
                                    </select>
                                </td>
                                {/* )} */}
                            </tr>
                        ))}
                    </tbody>
                ),
            },

            {
                Header: 'Action',
                accessor: 'product_data',
                // id: 'date',
                Cell: ({ cell: { value } }) => (
                    // <table>
                    <tbody>
                        {value && value.map((product, index) => (
                            <tr key={index}>
                                <td className="edit-delete-action justify-content-start d-flex gap-2">

                                    {/* View Link */}
                                    <Link
                                        to="#"
                                        style={{
                                            "--i": "#233882",
                                            color: product.date !== null ? "#233882" : "gray"
                                        }}
                                        className="p-2"
                                        onClick={product.date !== null ? () => ProductView(product.vdr_id) : (e) => e.preventDefault()}
                                    >
                                        <FaEye />
                                    </Link>

                                    {/* Delete Link */}
                                    <Link
                                        to="#"
                                        style={{
                                            "--i": "red",
                                            color: product.date !== null ? "red" : "gray"
                                        }}
                                        className="p-2"
                                        onClick={product.date !== null ? () => VendorDelete(product.vdr_id) : (e) => e.preventDefault()}
                                    >
                                        <MdDelete />
                                    </Link>

                                </td>
                            </tr>
                        ))}
                    </tbody>

                    // </table>
                ),
            },


            // {
            //     Header: 'Action',
            //     accessor: 'customer_type',
            //     accessor: 'actions',
            //     Cell: ({ row }) => (
            //         <div>
            //             <Button variant="secondary" onClick={() => handleViewProduct(row.original.id)} className="ms-2">View</Button>
            //         </div>
            //     ),
            // },

        ],
        []
    );

    console.warn("fgfg", Rows)
    const buttonname = "Receive Material";
    const buttonclass = "btn-added btn_custum_new";
    const title = "Product Details";
    const titlesec = "Actual Receive History";

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value); // No need to parseInt, keep it as a string
    };

    const filteredOrderList = selectedStatus ? orderlist.filter(item => item.customer_name === selectedStatus) : orderlist;

    const uniqueRows = Array.from(new Set(Rows.map(row => row.vender_id)))
        .map(vender_id => Rows.find(row => row.vender_id === vender_id));

    const uniqueComponents = Array.from(new Set(Rows.map(row => row.component_id)))
        .map(component_id => Rows.find(row => row.component_id === component_id));
    return (
        <>
            <ToastContainer />

            <div className='justify-content-center processing'>
                <div className='text-center'>
                    <Row>
                        <Col md={12} xs={12} lg={12} className='duedrop1'>
                            <Form.Select
                                aria-label="Default select example"
                                onChange={handleStatusChange}
                                value={selectedStatus}
                                style={{ border: '1px solid #8080802' }}
                            >
                                <option value=''>Customer Name</option>
                                {orderlist.map((order) => (
                                    <option key={order.customer_name} value={order.customer_name}>
                                        {order.customer_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                </div>
            </div>
            <Vendorproductt columns={vendorProductColumns} data={filteredOrderList} title={title} addvendor={buttonname} btnclass={buttonclass} />

            <hr />
            <Modal
                size="lg"
                show={modalState.addReceive}
                onHide={() => setModalState({ ...modalState, addReceive: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body>
                    <AddReceive onSave={() => { setModalState({ ...modalState, addReceive: false }); }} />
                </Modal.Body>
            </Modal>

            <Modal
                size="lg"
                show={modalState.orderProductView}
                onHide={() => setModalState({ ...modalState, orderProductView: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h5 style={{ color: "gray" }} className="card-title">Customer Product View Details</h5>
                </Modal.Header>

                <Modal.Body closeButton>
                    <CustumerProductview onSave={() => { setModalState({ ...modalState, orderProductView: false }); }} />
                </Modal.Body>
            </Modal>
            <Modal
                size="lg"
                show={modalState.orderVendorView}
                onHide={() => setModalState({ ...modalState, orderVendorView: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h5 style={{ color: "gray" }} className="card-title">Customer Vendor View Details</h5>
                </Modal.Header>
                <Modal.Body closeButton>
                    <VendorReceiveView onSave={() => { setModalState({ ...modalState, orderVendorView: false }); }} />
                </Modal.Body>
            </Modal>

            <>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Vendor Payment View Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>


                            <Form.Group className="mb-3">
                                <Form.Label> Price</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={modalData.unit_price}
                                    onChange={e => setModalData({ ...modalData, unit_price: e.target.value })}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>

                        {VendorManufactureID ?


                            <Button variant="primary" onClick={() => {

                                handleUpdate();
                            }}>
                                Update
                            </Button>
                            :
                            <Button variant="primary" onClick={() => {

                                handleSubmit1();
                            }}>
                                Save Changes
                            </Button>
                        }
                    </Modal.Footer>
                </Modal>
            </>

        </>
    );
};

export default VendorProductdetails;
